import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { Select, Input } from "../../inputs";

const VarietyHead = ({ linkableOptions, variety, linkCode, isParent, varietyId, removeVariety, updateVariety }) => {
    const handleUpdate = (name, value) => {
        updateVariety(name, value, varietyId);
    };

    const handleRemove = () => {
        removeVariety(varietyId);
    };

    return (
        <div className="variety-head">
            <div className="input-group -no-margin">
                <Input name="variety" value={variety} updateOnBlur={handleUpdate} />
                <button className="button -small" onClick={handleRemove} title="Delete Variety">
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </div>
            <div>
                <Select
                    name="linkCode"
                    options={[{ text: "Select Link", value: "" }, ...linkableOptions]}
                    value={linkCode}
                    updateOnChange={handleUpdate}
                    excludeSelect={true}
                    disabled={isParent}
                />
            </div>
        </div>
    );
};

export default VarietyHead;
